// @ts-expect-error Ignoring UIKit type errors
import changesetSet from 'ember-changeset/helpers/changeset-set';
// @ts-expect-error Ignoring UIKit type errors
import changesetGet from 'ember-changeset/helpers/changeset-get';
import type { TOC } from '@ember/component/template-only';
import ValidatedField, {
  type S as ValidatedFieldSig
} from '../validated-field.gts';
import Range, { type S as RangeSig } from '../range.ts';
import { fn } from '@ember/helper';
import { or } from 'ember-truth-helpers';

interface S {
  Element: RangeSig['Element'];
  Args: {
    payloadKey: ValidatedFieldSig['Args']['propertyName'];
  } & Pick<RangeSig['Args'], 'label' | 'min' | 'max' | 'step'> &
    Pick<ValidatedFieldSig['Args'], 'changeset' | 'errorClass'>;
  Blocks: { values: [] };
}

const ChangesetRange: TOC<S> = <template>
  <ValidatedField
    @propertyName={{@payloadKey}}
    @changeset={{@changeset}}
    @errorClass={{or @errorClass 'error-validated-input-display'}}
  >
    <Range
      @label={{@label}}
      @dataTest={{@payloadKey}}
      @min={{@min}}
      @max={{@max}}
      @step={{@step}}
      @value={{or (changesetGet @changeset @payloadKey) 0}}
      @onChange={{fn (changesetSet @changeset @payloadKey)}}
      ...attributes
    >
      <:values>
        {{#if (has-block 'values')}}
          {{yield to='values'}}
        {{/if}}
      </:values>
    </Range>
  </ValidatedField>
</template>;

export default ChangesetRange;
